<!-- Dialog Cotacao Global - Wave Header -->
<p-dialog
  [(visible)]="visivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '550px', height: 'auto', maxWidth: '95vw' }"
  (onShow)="onShow()">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-money-bill" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.titulo }}</h2>
        <p>{{ texts.subtitulo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">

    <!-- Campo: Dolar -> Guarani -->
    <div class="field" *ngIf="isVisivel('dolarGuarani')">
      <label for="cotacaoGlobalDolarGuarani">
        <span class="cotacao-flags">
          <img src="assets/images/usa-flag.svg" class="flag-img" alt="USA" />
          <span class="flag-separator">x</span>
          <img src="assets/images/paraguay-flag.jpg" class="flag-img" alt="Paraguay" />
        </span>
        {{ texts.dolar_guarani }}
      </label>
      <!-- es-PY: PYG sem decimais, ponto como milhar -->
      <p-inputNumber
        inputId="cotacaoGlobalDolarGuarani"
        [(ngModel)]="dolarGuaraniInput"
        [locale]="'es-PY'"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        [min]="0"
        [useGrouping]="true"
        [placeholder]="texts.placeholder"
        styleClass="w-full"
        inputStyleClass="w-full"></p-inputNumber>
    </div>

    <!-- Campo: Real -> Guarani -->
    <div class="field" *ngIf="isVisivel('realGuarani')">
      <label for="cotacaoGlobalRealGuarani">
        <span class="cotacao-flags">
          <img src="assets/images/br-flag.svg" class="flag-img" alt="Brasil" />
          <span class="flag-separator">x</span>
          <img src="assets/images/paraguay-flag.jpg" class="flag-img" alt="Paraguay" />
        </span>
        {{ texts.real_guarani }}
      </label>
      <!-- es-PY: PYG sem decimais, ponto como milhar -->
      <p-inputNumber
        inputId="cotacaoGlobalRealGuarani"
        [(ngModel)]="realGuaraniInput"
        [locale]="'es-PY'"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        [min]="0"
        [useGrouping]="true"
        [placeholder]="texts.placeholder"
        styleClass="w-full"
        inputStyleClass="w-full"></p-inputNumber>
    </div>

    <!-- Campo: Dolar -> Real -->
    <div class="field" *ngIf="isVisivel('dolarReal')">
      <label for="cotacaoGlobalDolarReal">
        <span class="cotacao-flags">
          <img src="assets/images/usa-flag.svg" class="flag-img" alt="USA" />
          <span class="flag-separator">x</span>
          <img src="assets/images/br-flag.svg" class="flag-img" alt="Brasil" />
        </span>
        {{ texts.dolar_real }}
      </label>
      <!-- pt-BR (BRL): 2 decimais com virgula como separador decimal -->
      <p-inputNumber
        inputId="cotacaoGlobalDolarReal"
        [(ngModel)]="dolarRealInput"
        [locale]="'pt-BR'"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [min]="0"
        [useGrouping]="true"
        [placeholder]="texts.placeholder"
        styleClass="w-full"
        inputStyleClass="w-full"></p-inputNumber>
    </div>

    <!-- Campo: Peso Argentino -> Guarani (apenas empresas PESO) -->
    <div class="field" *ngIf="isVisivel('pesoGuarani')">
      <label for="cotacaoGlobalPesoGuarani">
        <span class="cotacao-flags">
          <img src="assets/images/argentina-flag.svg" class="flag-img" alt="Argentina" />
          <span class="flag-separator">x</span>
          <img src="assets/images/paraguay-flag.jpg" class="flag-img" alt="Paraguay" />
        </span>
        {{ texts.peso_guarani }}
      </label>
      <!-- Aceita virgula como separador decimal (locale es-PY); fixa em 2 casas (NUMERIC(19,2)). -->
      <p-inputNumber
        inputId="cotacaoGlobalPesoGuarani"
        [(ngModel)]="pesoGuaraniInput"
        [locale]="'es-PY'"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [min]="0"
        [useGrouping]="true"
        [placeholder]="texts.placeholder_peso"
        styleClass="w-full"
        inputStyleClass="w-full"></p-inputNumber>
    </div>

  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelar()">
      {{ texts.fechar }}
    </button>
    <button
      pButton
      (click)="salvarCotacao()"
      [loading]="cotacaoCarregando"
      type="button">
      {{ texts.guardar }}
    </button>
  </ng-template>

</p-dialog>

<p-toast></p-toast>
